module.exports = __webpack_public_path__ + "img/icon112.69229544.png";